import React from 'react'
import { Button, useOverlay, DialogOverlay, DialogOverlayActions, Paragraph } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function TasksDoneOverlay({ title, message, goBackToGive }) {
  const overlay = useOverlay({ initiallyOpen: true })
  const [t] = useTranslation()

  const defaultTitle = t('task-viewer.finished-modal.heading', 'Way to go!')
  const defaultMessage = t(
    'tasks-done-overlay.surnames-done.message',
    'All the surnames are completed in this area. Go back to Get Involved to do another search.'
  )

  return (
    <DialogOverlay {...overlay} title={title || defaultTitle} nonClosable>
      <Paragraph>{message || defaultMessage}</Paragraph>
      <DialogOverlayActions>
        <Button data-testid="go-back-to-give" onClick={() => goBackToGive()} emphasis="high">
          {t('tasks-done-overlay.go-back.button', 'Go Back')}
        </Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}
